import React from 'react';
import { Row } from './styles/Row.styled';
import { ContentBlock } from './styles/FilterTabBlock.styled';
import ExperiencesCardFeatured from './ExperiencesCardFeatured';
import ExperiencesCardSmall from './ExperiencesCardSmall';
import ExperiencesCardMedium from './ExperiencesCardMedium';

export default function ExperiencesCardsBlock({ data, exporeFeatured, dir }) {
  const [experience, setExperience] = React.useState(false);

  const handleClick = (name) => setExperience(name === experience ? '' : name);

  return (
    <ContentBlock className="content active-content">
      <Row>
        {data.map(({ content }, index) => {
          if (exporeFeatured)
            return (
              <ExperiencesCardFeatured
                data={content}
                position={index % 2 === 0 ? 'position_right' : 'position_left'}
                dir={dir}
                isAllFeatured
              />
            );

          switch (content.type) {
            case 'featured':
              return <ExperiencesCardFeatured data={content} dir={dir} />;
            case 'medium':
              return (
                <ExperiencesCardMedium
                  experience={experience}
                  onClick={handleClick}
                  data={content}
                  dir={dir}
                />
              );
            case 'small':
              return (
                <ExperiencesCardSmall
                  experience={experience}
                  onClick={handleClick}
                  data={content}
                  dir={dir}
                />
              );
            default:
              return null;
          }
        })}
      </Row>
    </ContentBlock>
  );
}
